import React, { useEffect, useState } from "react"
import {
  Table,
  Row,
  Col,
  Card,
  CardBody,
  PaginationItem,
  PaginationLink,
  Dropdown,
  DropdownMenu,
  DropdownItem,
  DropdownToggle,
  Spinner,
} from "reactstrap"
import { Link } from "react-router-dom"
import { useHistory } from "react-router-dom"
import moment from "moment"
import "./style.css"
import Pagination from "../Pagination/index"
import ReactPaginate from "react-paginate"
import { set } from "lodash"

/**
 * This table populates when order data is received.
 * @param {Array} titleList
 * @param {Array} tableData
 * @returns {Object}
 */
const TableList = ({
  title,
  titleList,
  tableData,
  nextPage,
  totalPagesCount,
  pageNumberThreshold,
  orderType,
  setOrderType,
}) => {
  //Declaring the first number for the now
  let rowNumber = 1
  const history = useHistory()
  const [currentPage, setCurrentPage] = useState(0)
  // We start with an empty list of items.
  const [currentItems, setCurrentItems] = useState(null)
  const [pageCount, setPageCount] = useState(0)
  // Here we use item offsets; we could also use page offsets
  // following the API or data you're working with.
  const [itemOffset, setItemOffset] = useState(0)
  const [dropdownOpen, setDropdownOpen] = useState(false)

  useEffect(() => {
    console.log("table data__", tableData)
  }, [tableData, totalPagesCount])

  // Invoke when user click to request another page.
  const handlePageClick = event => {
    nextPage(event.selected + 1)
  }

  useEffect(()=>{
console.log("___________orderType___________________", orderType)
  },[orderType])

  return (
    <Row>
      <Col md={12}>
        <Card>
          <CardBody>
            <h4 className="mt-5">{title}</h4>
            {/* <Link to="/details"> */}
            {tableData.length > 0 ? (
              <div className="table-responsive">
                <Dropdown
                  isOpen={dropdownOpen}
                  toggle={() => setDropdownOpen(!dropdownOpen)}
                >
                  <DropdownToggle className="btn btn-secondary" caret>
                    {orderType} <i className="mdi mdi-chevron-down" />
                  </DropdownToggle>
                  <DropdownMenu>
                    {["Assigned", "Unassigned"].map(item => (
                      <DropdownItem
                        value={item}
                        onClick={e => {
                          setOrderType(item)
                        }}
                      >
                        {item}
                      </DropdownItem>
                    ))}
                  </DropdownMenu>
                </Dropdown>
                <Table className="table mb-0">
                  <thead>
                    <tr>
                      {titleList &&
                        titleList?.map((item, index) => {
                          return <th key={`title-${index}`}>{item}</th>
                        })}
                    </tr>
                  </thead>
                  <tbody>
                    {tableData.length > 0 &&
                      tableData?.map(item => {
                        return (
                          <>
                            {
                              <tr
                                id={item.id}
                                key={`order-${item.id}`}
                                onClick={() => {
                                  history.push(`/job/orderId?=${item.id}`)
                                }}
                              >
                                <th scope="row">
                                  {pageNumberThreshold + rowNumber++}
                                </th>
                                <td>{item?.name}</td>
                                <td>{item?.scheduled ? "True" : "False"}</td>
                                <td>{item?.orderId}</td>
                                {/* {console.log("item?.from__", item)} */}
                                <td>
                                  {moment
                                    .utc(item?.from?.seconds * 1000)
                                    .utcOffset("+05:30")
                                    .format("h:mm:ss a, DD/MM/YYYY")}
                                </td>
                                <td>
                                  {moment
                                    .utc(item?.to?.seconds * 1000)
                                    .utcOffset("+05:30")
                                    .format("h:mm:ss a, DD/MM/YYYY")}
                                </td>
                              </tr>
                            }
                          </>
                        )
                      })}
                  </tbody>
                </Table>
                <div className="d-flex p-d-2">
                  <ReactPaginate
                    previousLabel="Previous"
                    nextLabel="Next"
                    pageClassName="page-item"
                    pageLinkClassName="page-link"
                    previousClassName="page-item"
                    previousLinkClassName="page-link"
                    nextClassName="page-item"
                    nextLinkClassName="page-link"
                    breakLabel="..."
                    breakClassName="page-item"
                    breakLinkClassName="page-link"
                    pageCount={totalPagesCount}
                    marginPagesDisplayed={2}
                    pageRangeDisplayed={10}
                    onPageChange={handlePageClick}
                    containerClassName="pagination"
                    activeClassName="active"
                    // forcePage={7}
                  />
                  {/* <Pagination />
                {totalPagesCount.map((page, i) => {
                  return (
                    <PaginationItem
                      active={i === currentPage}
                      key={i}
                      style={{ listStyleType: "none" }}
                    >
                      <PaginationLink
                        onClick={e => {
                          setCurrentPage(i)
                          nextPage()
                        }}
                      >
                        {i + 1}
                      </PaginationLink>
                    </PaginationItem>
                  )
                })} */}
                </div>
              </div>
            ) : (
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  minHeight: "60vh",
                }}
              >
                <Spinner />
              </div>
            )}

            {/* </Link> */}
          </CardBody>
        </Card>
      </Col>
    </Row>
  )
}

export default TableList

//TODO: PLACE THE TABLE DATA COMPLETELY ON THE MISSING AREA WHEN THE API IS READY
